import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Typography from '../../common/typography';
import { PlanTileToggleContainer, PlanTileToggleItem } from './styles';
const PlanTileToggle = ({ duration, setDuration, color, }) => {
    const { t } = useTranslation();
    const handleMonthly = () => {
        setDuration('monthly');
    };
    const handleYearly = () => {
        setDuration('yearly');
    };
    return (_jsxs(PlanTileToggleContainer, { "$color": color, children: [_jsx(PlanTileToggleItem, { onClick: handleMonthly, "$active": duration === 'monthly', children: _jsx(Typography, { elementTheme: "overline", nowrap: true, children: t('plansDurations|monthlyToggle') }) }), _jsx(PlanTileToggleItem, { onClick: handleYearly, "$active": duration === 'yearly', children: _jsx(Typography, { elementTheme: "overline", nowrap: true, children: t('plansDurations|yearlyToggle') }) })] }));
};
export default PlanTileToggle;
